export const departmentList = [
    "English",
    "History",
    "Political Science",
    "Economics",
    "Sanskrit",
    "Hindi",
    "Urdu",
    "Philosophy",
    "Geography",
    "Sociology",
    "Education",
    "Psychology",
    "LaW",
    "Physical Education",
    "Mathematics",
    "Chemistry",
    "Physics",
    "Botany",
    "Zoology",
    "Office and Library",
    "Fourth Grade"
]